/*
 * EntitySubDisplay3.tsx
 * Sub Entieties etc. in Tabs anzeigen.
 * Wrapper für EntityDisplayInner mit Nachlade-Funktionalität.
 *
 * Created by Dr. Maximillian Dornseif 2023-10-10 in huWaWi3 33.1.0
 * Copyright (c) 2020, 2023 HUDORA GmbH
 */

import { Stack } from '@fluentui/react/lib/Stack';
import { LadeChecker } from '@hudora/hd-react-components';
import { DocumentNode } from 'graphql';
import React from 'react';
import { useQuery } from 'urql';

import { IEntity } from '../../../types';
import { getValueDeep } from '../../util/get-value-deep';
import { EntityPageInner3 } from './EntityPageInner3';

export interface EntitySubDisplay3Props {
  nr: string; // Designator
  entityQuery: DocumentNode;
  schemaName: string;
  mutation?: DocumentNode; // Bearbeiten einer SubEntitiy
  children?: React.ReactNode;
}

/** Anzeige für  untergeordnete "Entities", wis zB Lieferadressen etc.
 * Führt selber die Query aus. Sie Query muss ein `entity` haben.
 * Wenn es sich um ein SubEntity, wie EDI-Daten zu einem Kunden,
 * Oder den Versandanweisungen zu einem Kunden handelt, kann man
 * diese auch neu zufügen, wenn createMutation übrgeben wird
 */
export const EntitySubDisplay3 = (props: EntitySubDisplay3Props) => {
  const [result] = useQuery({
    query: props.entityQuery,
    variables: { nr: props.nr },
    pause: !props.nr,
  });
  const { fetching: loading, error, data } = result;

  if (!props.nr) {
    return null;
  }

  const entity = getValueDeep<IEntity>('entity', data);

  if (error) {
    return <LadeChecker loading={loading} error={error} label={`Lade Daten für ${props.nr} …`} />;
  }

  const noData = !entity ? (
    <Stack.Item align="center">
      <Stack verticalAlign="center">{`Keine Daten für "${props.nr}" erhalten - möglicherweise ein Fehler.`}</Stack>
    </Stack.Item>
  ) : null;
  console.log(data, !props.nr);
  return (
    <div data-testid="EntitySubDisplay">
      <LadeChecker loading={loading} error={error} label={`Lade Daten für ${props.nr} …`} />
      <Stack tokens={{ childrenGap: '0.2em' }} grow>
        {noData || (
          <EntityPageInner3 entity={entity} schemaName={props.schemaName} mutation={props.mutation}>
            {props.children}
          </EntityPageInner3>
        )}
      </Stack>
    </div>
  );
};
